import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetConsumablesPaginated = () =>
  useMutation({
    mutationFn: (data) => client(`resources/consumables`, { data }),
  });

export const useAddConsumables = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/consumables/add`, {
        data,
        successMessage: "Consumable has been added successfully",
      }),
  });
export const useEditConsumables = () =>
  useMutation({
    mutationFn: (data) =>
      client(
        `resources/consumables/edit`,
        {
          method: "put",
          successMessage: "Consumable has been updated successfully",
        },
        { data }
      ),
  });
export const useAddConsumablesBulk = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/consumables/add/bulk`, {
        data,
        successMessage: "Consumables has been added successfully",
      }),
  });

export const useConsumableSummary = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/consumables/summary/${data}`, { data }),
  });
export const useGetConsumable = () =>
  useMutation({
    mutationFn: (data) => client(`resources/consumables/${data}`),
  });
